"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Iframe = void 0;
var _Button = require("../../../../../UI/Button");
var _Icon = require("../../../../../UI/Icon");
var _Iframe = _interopRequireDefault(require("./Iframe.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Iframe = function Iframe(props) {
  var iframeData = props.iframeData,
    onClose = props.onClose;
  var styles = (0, _Iframe.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(iframeData === null || iframeData === void 0 ? void 0 : iframeData.title) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-TaskManager__iframe__title'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: iframeData === null || iframeData === void 0 ? void 0 : iframeData.title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-TaskManager__iframe__content'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
        title: iframeData === null || iframeData === void 0 ? void 0 : iframeData.title,
        frameBorder: "0",
        width: "100%",
        height: "100%",
        src: iframeData === null || iframeData === void 0 ? void 0 : iframeData.src,
        allowFullScreen: true
      })
    }), (iframeData === null || iframeData === void 0 ? void 0 : iframeData.title) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-TaskManager__iframe__close-btn'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        color: "primary",
        view: "alternate",
        shape: "round",
        onClick: onClose,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "Close",
          width: 14,
          height: 14
        })
      })
    })]
  });
};
exports.Iframe = Iframe;